import React from "react";
import { MdClose } from "react-icons/md";
import ContainedButton from "components/layout/form/containedButton";

import {
  Container,
  ContainerButtons,
  ModalHeader,
  ModalStyle,
  Alert,
} from "./styles";

function DebitSuccessModal({ openModal, modalFunction, text }) {
  return (
    <ModalStyle
      show={openModal}
      animation={false}
      centered
      onHide={() => modalFunction(false)}
    >
      <ModalHeader>
        <span>Débito automático</span>
        <MdClose size={24} onClick={() => modalFunction(false)} />
      </ModalHeader>
      <Container>
        <Alert dangerouslySetInnerHTML={{ __html: text }} />
        <ContainerButtons>
          <ContainedButton onClick={() => modalFunction(false)}>
            OK
          </ContainedButton>
        </ContainerButtons>
      </Container>
    </ModalStyle>
  );
};

export default DebitSuccessModal;
